export const GAME_DURATION_SECONDS = 90;

export const TEMPO_STAGE_THRESHOLDS = {
	earlyMin: 61,
	midMin: 16,
	finalMin: 0,
} as const;